export default "__VITE_PUBLIC_ASSET__d3f88c52__"